import React, { useState, useEffect, useRef } from 'react';
import styles from './nestedDropdown.module.scss';

export const NestedDropdown = ({
  clients = [],
  selectedClient,
  defaultLabel = 'Select Hotel Type',
  onSelection,
}) => {
  const [selectedValue, setSelectedValue] = useState(
    selectedClient?.title || defaultLabel
  );
  const [showMenu, setShowMenu] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelectedValue(selectedClient?.title || defaultLabel);
  }, [selectedClient, defaultLabel]);
  
  // Add click outside listener
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    }
    
    // Add event listener when the dropdown is shown
    if (showMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    // Cleanup the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMenu]);

  const handleSelection = (value, label) => {
    const displayLabel = label || defaultLabel;
    setSelectedValue(displayLabel); // Update the displayed value 
    onSelection(value, displayLabel); // Notify parent about the selection
    setShowMenu(false); // Close dropdown menu
  };

  const renderNestedMenu = (clients) => {
    return clients.map((client) => (
      <li key={client.id} className={styles.dropdownItem}>
        <span
          onClick={(e) => {
            e.stopPropagation();
            handleSelection(client.id, client.title); // Select the client
          }}
        >
          {client.title}
        </span>
        {client.child_clients?.length > 0 && (
          <ul className={styles.nestedDropdown}>
            {renderNestedMenu(client.child_clients)}
          </ul>
        )}
      </li>
    ));
  };

  return (
    <div className={styles.dropdown} ref={dropdownRef}>
      <button
        className={`${styles.dropdownButton} ${selectedValue === defaultLabel ? styles.placeholder : ''}`}
        type="button" // Set type to "button" to prevent form submission
        onClick={() => setShowMenu(!showMenu)}
      >
        {selectedValue} <span className={styles.arrow}>▼</span>
      </button>
      {showMenu && (
        <ul 
          className={styles.dropdownMenu}
          onClick={(e) => {
            // Prevent clicks on the dropdown from closing it
            e.stopPropagation();
          }}
        >
          <li
            className={styles.dropdownItem}
            onClick={(e) => {
              e.stopPropagation();
              handleSelection(null, 'Stand Alone Hotel'); // Null for Stand Alone Hotel
            }}
          >
            Stand Alone Hotel
          </li>
          <li 
            className={`${styles.dropdownItem} ${styles.nested}`}
            onClick={(e) => {
              // Don't close the dropdown when clicking on this item
              e.stopPropagation();
            }}
          >
            Parent Group
            <ul className={styles.nestedDropdown}>
              {renderNestedMenu(clients)} {/* Render clients */}
            </ul>
          </li>
        </ul>
      )}
    </div>
  );
};
